// import React from "react";
import { useState } from "react";
import InnerHero from "../components/InnerHero";
import productsData from "../data/products";
import ProductModal from "../components/ProductCard";
import UsageSafety from "../components/UsageSafety";
import CTASection from "../components/CTASection";

function Herbicide() {
    const [selectedProduct, setSelectedProduct] = useState(null);

    // 🔹 SIRF INSECTICIDE PRODUCTS
    const insecticideProducts = productsData.filter(
        product => product.category === "Herbicide"
    );
    return (
        <>
            <InnerHero
                title="Herbicides"
                subtitle="Effective weed control solutions to protect crops from unwanted competition and improve productivity."
                breadcrumb="Home / Products"
                bgImage="/images/img/herb.jpg"
            />

            <section className="category-intro-section">
                <div className="container">
                    <div className="row align-items-center">

                        {/* LEFT CONTENT */}
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="category-intro-content">
                                <h6 className="section-subtitle">CATEGORY OVERVIEW</h6>
                                <h2>
                                    Powerful <span>Weed Control</span> for Better Crop Growth
                                </h2>

                                <p>
                                    Weeds compete with crops for nutrients, water, sunlight,
                                    and space, significantly reducing crop growth and yield
                                    potential. Effective weed management is essential for
                                    achieving healthy and uniform crop development.
                                </p>

                                <p>
                                    Goodweel Crop Care herbicides are designed to control a wide
                                    range of grasses and broad-leaf weeds without harming the
                                    main crop. Our formulations are developed through scientific
                                    research and tested under real Indian farming conditions.
                                </p>

                                <p>
                                    With timely application and reliable performance, our
                                    herbicides help farmers maintain clean fields, reduce
                                    labor costs, and maximize crop productivity.
                                </p>
                            </div>
                        </div>

                        {/* RIGHT IMAGE */}
                        <div className="col-lg-6">
                            <div className="category-intro-image">
                                <img
                                    src="/images/img/17.jpg"
                                    alt="Herbicides Weed Control"
                                    className="img-fluid"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* SECTION HEADING */}
            <div className="container text-center my-5">
                <h2 className="section-title">
                    Our <span>Herbicide Products</span>
                </h2>
                <p className="section-desc">
                    Explore our range of advanced herbicides developed to
                    control weeds effectively while ensuring crop safety
                    and long-term field cleanliness.
                </p>
            </div>

            {/* PRODUCTS GRID (CSS SAME AS PRODUCT PAGE) */}
            <div className="container">
                <div className="row">
                    {insecticideProducts.map(product => (
                        <div
                            className="col-lg-3 col-md-4 col-sm-6 mb-4 Product-col"
                            key={product.id}
                        >
                            <div
                                className="product-card"
                                onClick={() => setSelectedProduct(product)}
                            >
                                <img
                                    src={product.image}
                                    alt={product.name}
                                />
                                <div className="product-overlay">
                                    <h6>{product.name}</h6>
                                </div>
                            </div>
                        </div>
                    ))}

                    {/* SAFETY CHECK */}
                    {insecticideProducts.length === 0 && (
                        <p className="text-center mt-4">
                            No Herbicide products available at the moment.
                        </p>
                    )}
                </div>
            </div>

            {/* PRODUCT DETAILS MODAL (UNCHANGED) */}
            {selectedProduct && (
                <ProductModal
                    product={selectedProduct}
                    close={() => setSelectedProduct(null)}
                />
            )}
            <UsageSafety />
            <CTASection />

        </>
    );
};

export default Herbicide;
